import {
  FilterType,
  buildPerformanceInsightsSummaryDatatableFilter,
  usePerformanceInsightsSummaryDatatable,
} from 'generated/resources/datatable.graphql'
import { AnalyticsPageLegalEntitiesFragment } from 'generated/resources/graphql'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

const legalEntitiesFilter = (
  source: ReturnType<typeof usePerformanceInsightsSummaryDatatable>,
  legalEntities: AnalyticsPageLegalEntitiesFragment[]
) => {
  return buildPerformanceInsightsSummaryDatatableFilter(source, {
    title: i18n.t('performance_process.analytics.datatable.filters.legal_entity'),
    path: 'legalEntityId',
    identifier: 'legalEntityIds',
    type: FilterType.Integer,
    default: true,
    categories: [
      {
        kind: 'MultipleChoice',
        operation: 'in',
        options: legalEntities.map(({ legalName, id }) => ({
          label: legalName,
          value: id,
        })),
      },
    ],
    onUpdateValue(value) {
      track(trackingEvents.performanceAnalytics.insightsSummaryFilterApplied, {
        type: 'legalEntityIds',
        value,
      })
    },
  })
}

export default legalEntitiesFilter
